module.exports = __webpack_public_path__ + "static/media/twitterIcon.5517b732.svg";